import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useJuryAuth } from '@/context/JuryAuthContext';

const JuryProtectedRoute = ({ children }) => {
  const { juror, loading } = useJuryAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]" data-testid="jury-loading">
        <div className="text-[var(--ink-muted)] tracking-[0.3em] uppercase text-xs">Loading…</div>
      </div>
    );
  }
  if (!juror) return <Navigate to="/jury-chamber/login" state={{ from: location }} replace />;
  return children;
};

export default JuryProtectedRoute;
